import React from "react";
import * as S from "./styles";

function CardPlan({ data }) {
  const { title, info, benefits, footer } = data

  return (
    <S.Container>
      <S.Title>{title}</S.Title>
      {benefits.map(benefit => (
        <S.Topic>{benefit}</S.Topic>
      ))}
      {info && <S.Topic>{info}</S.Topic>}
      {footer.length > 0 && <S.Separator />}
      {footer.map(topics => (
        <S.Topic>{topics}</S.Topic>
      ))}
    </S.Container>
  );
}

export default CardPlan;
